import React from "react";

const Empty = props => {
    return (
        <div className="tab-pane  show active" id="absence-pane" role="tabpanel" aria-labelledby="absence-tab">
            <div className="content">

            </div>
        </div>
    );
}

export default Empty;